<mat-card>
<div class="details-view-container" *ngIf="deviceObject" fxLayout="column" fxLayoutGap="15px" >

  <div fxLayout="row" fxLayoutGap="15px" class="button-container">
    <button [disabled]="!(userPermissions | async).license.write" (click)="modify()" mat-stroked-button color="primary">
      <mat-icon>create</mat-icon> <span> Edytuj</span>
    </button>
    <button [disabled]="!(userPermissions | async).license.admin_root" (click)="delete()" mat-stroked-button color="warn">
      <mat-icon>delete</mat-icon> <span> Usuń</span>
    </button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane urządzenia</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="50" header="Rodzaj urządzenia" [value]="deviceObject.typeOfDevice?.name"></app-detail>
              <app-detail fxFlex="50" header="Nazwa" [value]="deviceObject.name"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="50" header="Numer seryjny" [value]="deviceObject.serialNumber"></app-detail>

              <app-detail fxFlex="50" header="Numer wewnętrzny" [value]="deviceObject.extensionNumber"></app-detail>

            </div>

            <div fxLayout="row">
              <app-detail fxFlex="50" header="Notatka" [value]="deviceObject.note"></app-detail>

              <app-detail fxFlex="50" header="Użytkownik"
                          [value]="deviceObject.user.firstName + ' ' + deviceObject.user.lastName"
                          [link]="deviceObject.user ? ['/urzadzenia/uzytkownicy/szczegoly/', deviceObject.user.uuid] : undefined">
              </app-detail>
            </div>

            <div fxLayout="row">
              <app-detail-bool fxFlex="50" header="Szyfrowanie dysku" [value]="deviceObject.diskEncryption"></app-detail-bool>
              <app-detail-bool fxFlex="50" header="Wymuszenie zmiany hasła systemowego" [value]="deviceObject.requirePasswordChange"></app-detail-bool>
            </div>

          </mat-card>
        </div>
      </div>

    </div>
  </div>

  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
  <mat-card fxFlex="50">
    <div fxLayout="column" fxLayoutGap="15px">

      <table mat-table [dataSource]="licenses" matSort>
        <ng-container matColumnDef="typeOfLicense">
          <th mat-header-cell *matHeaderCellDef> Rodzaj licencji </th>
          <td mat-cell *matCellDef="let element">
            <ng-container>
              <a class="default-link" [routerLink]="['/urzadzenia/licencje/szczegoly', element.uuid]">
                {{ element?.typeOfLicense?.name}}
              </a>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="licenseNumber">
          <th mat-header-cell *matHeaderCellDef> Numer licencji </th>
          <td mat-cell *matCellDef="let element">
            {{ element?.licenseNumber}}
          </td>
        </ng-container>

        <ng-container matColumnDef="expirationDate">
          <th mat-header-cell *matHeaderCellDef> Data ważności do </th>
          <td mat-cell *matCellDef="let element">
            <a *ngIf="element?.expirationDate">{{element?.expirationDate | date: 'yyyy-MM-dd'}}</a>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['typeOfLicense', 'licenseNumber', 'expirationDate']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['typeOfLicense', 'licenseNumber', 'expirationDate'];"></tr>
      </table>
    </div>
  </mat-card>
  </div>
</div>
</mat-card>
